export { downloadBlobFile } from "../../../utils/download";

export const normalizeProspectingContact = (contact) => ({
  id: contact.id,
  name: contact.full_name,
  job_title: contact.job_title,
  email: contact.email,
  direct_phone_number: contact.work_phone ?? contact.phone ?? null,
  mobile_phone_number: contact.mobile_phone ?? null,
  city: contact.city,
  state: contact.state,
  country: contact.country,
  company: contact.company
    ? {
        id: contact.company.id,
        name: contact.company.name,
        city: contact.company.city,
        state: contact.company.state,
        country: contact.company.country,
      }
    : null,
});

export const dedupeProspectingContactsById = (contacts) => {
  const seenIds = new Set();
  const seenNamePhonePairs = new Set();

  return contacts.filter((contact) => {
    if (contact?.id == null) {
      const normalizedName = String(contact?.name || "")
        .trim()
        .toLowerCase();
      const normalizedPhone = String(
        contact?.direct_phone_number || contact?.mobile_phone_number || "",
      )
        .replace(/\D/g, "");

      if (!normalizedName || !normalizedPhone) {
        return true;
      }

      const pairKey = `${normalizedName}::${normalizedPhone}`;
      if (seenNamePhonePairs.has(pairKey)) {
        return false;
      }

      seenNamePhonePairs.add(pairKey);
      return true;
    }

    const id = String(contact.id);
    if (seenIds.has(id)) {
      return false;
    }

    const normalizedName = String(contact?.name || "")
      .trim()
      .toLowerCase();
    const normalizedPhone = String(
      contact?.direct_phone_number || contact?.mobile_phone_number || "",
    )
      .replace(/\D/g, "");

    if (normalizedName && normalizedPhone) {
      const pairKey = `${normalizedName}::${normalizedPhone}`;
      if (seenNamePhonePairs.has(pairKey)) {
        return false;
      }
      seenNamePhonePairs.add(pairKey);
    }

    seenIds.add(id);
    return true;
  });
};
